import React from 'react';

interface SchoolViewTableSkeletonProps {
  rows?: number;
  /** Columns after the school name: the view's own columns. */
  cols?: number;
  /** Column indexes (after the name) whose cells stack two short lines, like Control's last milestone. */
  twoLineCols?: number[];
}

const DEFAULT_ROWS = 8;
const DEFAULT_COLS = 5;
const NAME_WIDTHS = ['w-48', 'w-64', 'w-56', 'w-44', 'w-52', 'w-40', 'w-60', 'w-48'];

const Bone = ({ className }: { className: string }) => <div className={`skeleton ${className}`} />;

/** Mirrors `SchoolViewTable`: name + location on the left, one pill or short value per view column. */
const SchoolViewTableSkeleton: React.FC<SchoolViewTableSkeletonProps> = ({ rows = DEFAULT_ROWS, cols = DEFAULT_COLS, twoLineCols = [] }) => (
  <div className="card">
    <div className="overflow-x-auto">
      <table className="w-full">
        <thead>
          <tr className="border-b border-border">
            <th className="py-3 px-4"><Bone className="h-3 w-16" /></th>
            {Array.from({ length: cols }).map((_, i) => (
              <th key={i} className="py-3 px-4 w-[140px]"><Bone className="h-3 w-20" /></th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-100">
          {Array.from({ length: rows }).map((_, i) => (
            <tr key={i} className={i % 2 === 0 ? '' : 'bg-surface-secondary/30'}>
              <td className="px-4 py-2.5">
                <div className="space-y-1.5">
                  <Bone className={`h-4 ${NAME_WIDTHS[i % NAME_WIDTHS.length]}`} />
                  <Bone className="h-3 w-32" />
                </div>
              </td>
              {Array.from({ length: cols }).map((_, j) => (
                <td key={j} className="px-4 py-2.5">
                  {twoLineCols.includes(j) ? (
                    <div className="space-y-1"><Bone className="h-3 w-20" /><Bone className="h-2.5 w-12" /></div>
                  ) : (
                    <Bone className={j === 0 ? 'h-5 w-24 rounded-full' : 'h-3.5 w-16'} />
                  )}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);

export default SchoolViewTableSkeleton;
